'use strict';

angular.module('casist.auth', [
  'OAuthHTTPInterceptor-buffer',
  'ngCookies'
]);